import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// register globally 注册全局组件
Vue.component('svg-icon', SvgIcon)
/**
 * webpack 的 api
 * 需要读取模块的文件的所在目录
 * 是否遍历子目录
 * 匹配的规则（正则表达式）
 */
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
